module.exports = __webpack_public_path__ + "static/media/22ESCWA15.82e19c1f.jpg";